import { api } from "./api";
import { getSessionId } from "./flow";

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

export const captureUtm = () => {
  const params = new URLSearchParams(window.location.search);
  const found = {};
  UTM_KEYS.forEach((k) => params.get(k) && (found[k] = params.get(k)));
  if (Object.keys(found).length) localStorage.setItem("fs_utm", JSON.stringify(found));
};

export const getUtm = () => {
  try { return JSON.parse(localStorage.getItem("fs_utm")) || {}; } catch { return {}; }
};

export const track = (name, props = {}) => {
  api.post("/events", { name, session_id: getSessionId(), props, utm: getUtm() }).catch(() => {});
};
